import { render } from "./EventItemSubmittedPage.vue?vue&type=template&id=e8b7dffe&scoped=true"
import script from "./EventItemSubmittedPage.vue?vue&type=script&lang=js"
export * from "./EventItemSubmittedPage.vue?vue&type=script&lang=js"

import "./EventItemSubmittedPage.vue?vue&type=style&index=0&id=e8b7dffe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8b7dffe"]])

export default __exports__